import { render } from "./BaseSpinner.vue?vue&type=template&id=e5ed833a&scoped=true"
import script from "./BaseSpinner.vue?vue&type=script&lang=js"
export * from "./BaseSpinner.vue?vue&type=script&lang=js"

import "./BaseSpinner.vue?vue&type=style&index=0&id=e5ed833a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5ed833a"]])

export default __exports__